export { default as AnimAssetsCanvas } from './modules/AnimAssetsCanvas'
export { default as AnimTextScroll } from './modules/AnimTextScroll'
export { default as AthletesList } from './modules/AthletesList'
export { default as BannerApp } from './modules/BannerApp';
export { default as CookieConsent } from './modules/CookieConsent';
// export { default as Example } from './modules/Example'
export { default as Filter } from './modules/Filter'
export { default as FilterAthletes } from './modules/FilterAthletes'
export { default as FormContact } from './modules/FormContact'
export { default as FormNewsletter } from './modules/FormNewsletter'
export { default as FormZipcode } from './modules/FormZipcode'
export { default as Header } from './modules/Header'
export { default as Load } from './modules/Load'
export { default as ModalContent } from './modules/ModalContent'
export { default as ModalContentTrigger } from './modules/ModalContentTrigger'
export { default as ModalMenu } from './modules/ModalMenu'
export { default as Schedule } from './modules/Schedule'
export { default as Scroll } from './modules/Scroll'
export { default as SkipContent } from './modules/SkipContent'
export { default as Slider } from './modules/Slider'
